// Crear una función para agregar un stylesheet si no existe
function crearOObtenerStylesheet(id) {
  let stylesheet = document.getElementById(id);
  if (!stylesheet) {
    // Crear un nuevo <style> si no existe
    stylesheet = document.createElement("style");
    stylesheet.id = id;
    document.head.appendChild(stylesheet);
  }
  return stylesheet.sheet;
}

function addClassDataSwatchBefore(elemento, matchingColor) {
  // Obtener el stylesheet dinámico
  const sheet = crearOObtenerStylesheet("mi-stylesheet-dinamico");
  // Obtener el valor del atributo data-swatch
  const swatch = elemento.getAttribute("data-swatch");
  // Comprobar si la regla ya existe
  let reglaExiste = false;
  for (let i = 0; i < sheet.cssRules.length; i++) {
    if (
      sheet.cssRules[i].selectorText === `[data-swatch="${swatch}"]::before`
    ) {
      reglaExiste = true;
      break;
    }
  }

  // Agregar la regla si no existe
  if (!reglaExiste) {
    if (matchingColor) {
      if (matchingColor.image !== "") {
        sheet.insertRule(
          `
          label.filter__label[data-swatch="${swatch}"]::before {  
            display: block;         
            background-color: transparent !important;
            background-image: url(${matchingColor.url});            
          }
        `,
          sheet.cssRules.length
        );
      } else {
        sheet.insertRule(
          `
          label.filter__label[data-swatch="${swatch}"]::before {
            display: block;
            background-color: ${matchingColor.color}; 
          }
        `,
          sheet.cssRules.length
        );
      }
    }
  }
}

function adjustColorImageOption(label) {
  var colorName = label.getAttribute("data-swatch")?.toLowerCase()?.trim();
  // Buscar el metaobject correspondiente
  var matchingColor = colorsMetaobject.filter((color) =>
    color.translates
      .toLowerCase()
      .split(",")
      .map((word) => word.trim())
      .includes(colorName)
  )[0];

  addClassDataSwatchBefore(label, matchingColor);

  // Si se encuentra un color coincidente, aplica el background-color
  if (matchingColor && label.classList.contains("opt-label--swatch")) {
    if (matchingColor.image !== "") {
      label.style.backgroundColor = "transparent !important";
      label.style.backgroundImage = "url(" + matchingColor.url + ")";
      label.style.backgroundSize = "contain";
      label.setAttribute("data-swatch", "");
    } else {
      label.style.backgroundColor = matchingColor.color;
    }
  }
}

// para procesar los label
function processSwatchLabels(productCard) {
  const swatchLabels = productCard.querySelectorAll("label.opt-label--swatch");
  swatchLabels.forEach((label) => {
    adjustColorImageOption(label);
  });
}

// Configurar el MutationObserver
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      // Si el nodo añadido es un elemento y no un nodo de texto, busca dentro de él
      if (node.nodeType === 1) {
        // Verifica si es un elemento
        // Si el nodo añadido es un <product-card>
        if (node.nodeName.toLowerCase() === "product-card") {
          processSwatchLabels(node);
        }
        // O busca <product-card> dentro de sus descendientes
        else {
          const productCards = node.querySelectorAll("product-card");
          productCards.forEach((card) => processSwatchLabels(card));
        }
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Selecciona el contenedor a observar
  const targetNode = document.body;
  // Opciones para el observer (observa nodos hijos y subárbol)
  const config = { childList: true, subtree: true };
  // Inicia el observer
  observer.observe(targetNode, config);
  // También puedes buscar elementos existentes en la carga inicial
  document.querySelectorAll("product-card").forEach(processSwatchLabels);
  document
    .querySelectorAll("label.opt-label--swatch")
    .forEach(adjustColorImageOption);

  document
    .querySelectorAll("label.filter__label")
    .forEach(adjustColorImageOption);
});
